
import {
  Button, Form, Input, Radio, Select
} from 'antd';
import Text from 'antd/lib/typography/Text';
import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as yup from 'yup';
import { findLodash, objectToFormData } from '../../../utils';
import { addCategories } from './../../../actions/categories';
import "./../styles/setting.css";
const { Option } = Select;

const { TextArea } = Input;

const ValidationSchema = yup.object().shape({
  name: yup
    .string()
    .required('Please provide category name'),
  // description: yup.string(),
  // account_code: yup.string(),
});

const AddCategory = (props) => {
  const [form] = Form.useForm();
  const { id: currentId, parentId: parent_id } = props;
  const [categoryType, setRadioValue] = React.useState('main');
  const [categoriesData, setCategoriesData] = React.useState([]);
  const dispatch = useDispatch();
  const categoriesResponse = useSelector(state => state.categories.categories || {});

  const onChange = e => {
    setRadioValue(e.target.value);
  };

  React.useEffect(() => {
    if (categoriesResponse.success) {
      const { data: { response: { categories = [] } = {} } = {} } = categoriesResponse;
      setCategoriesData(categories);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    form.resetFields();
    if (categoriesResponse.success && currentId) {
      const editValues = parent_id ?
        (findLodash([...(findLodash(categoriesResponse.data.response.categories, { id: parent_id })).sub_categories], { id: currentId })) :
        (findLodash(categoriesResponse.data.response.categories, { id: currentId }));
      form.setFieldsValue({
        name: editValues.name,
        account_code: editValues.account_code,
        description: editValues.description,
        parent_id: editValues.parent_id,
      });

      setRadioValue(parent_id ? 'subCat' : 'main');
      setCategoriesData(categoriesResponse.data.response.categories);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const handleCancelButton = () => {
    form.resetFields();
    props.handleCancel();
  }


  const renderMainCategoryUi = () => {
    return (
      <Form layout="vertical"
        form={form}
        onFinish={handleSubmit}
        className="modal-form"
      >
        <Form.Item label="Category Name" name="name" required={true} rules={[{ required: true, message: 'Please enter category name' }]}>
          <Input placeholder="Category name" />
        </Form.Item>
        <Form.Item label="Account Code" name="account_code">
          <Input placeholder="Enter Category Code" />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <TextArea
            placeholder="Enter Description"
            autoSize={{ minRows: 3, maxRows: 5 }}
          />
        </Form.Item>
        {/* <div className="dividerText">
             Define rules for this category
          </div>
           <Form.Item name="checkboxGroup" valuePropName="checked" style={{ marginBottom: '5px' }}>
            <Collapse accordion className='customCollapse'>
                  <Panel header="Expense" key="1">
                    <Checkbox.Group onChange={onCheckChange} defaultValue={checkboxesData}>
                        <p>Bill Mandatory <Checkbox value="is_bill_mandatory" /></p>
                        <p>Documents required<Checkbox value="is_document_mandatory" /></p>
                        <p>Allow users to submit future bill date<Checkbox value="is_submited_feature_bill" /></p>
                    </Checkbox.Group>
                  </Panel>
              </Collapse>
            </Form.Item>
           <Collapse accordion className='customCollapse'>
                <Panel header="Category based Approval Flow" key="2">
                  <Steps direction="vertical" size="small" current={reportsApprovalData.length + 1 || 100}>
                    {reportsApprovalData && reportsApprovalData.map((item, index) =>
                      <Step key={item.id} title={item.role_name} icon={<div className="stepsNumber">{index+1}</div>} />
                    )}
                  </Steps>
                </Panel>
            </Collapse> */}
        {/* <Collapse accordion>
                <Panel header="Required expense fields" key="3">
                </Panel>
            </Collapse> */}
        {/* <Form.Item label="View Load Money Accounts">
               <Select
                 style={{ width: '400px' }}
                 mode="multiple"
                 getPopupContainer={(trigger) => trigger.parentNode}
                 placeholder="Select account"
               >
                   <Option>item</Option>
               </Select>
           </Form.Item> */}
        <Button key="1" htmlType="submit" className="formButton mt3 primaryButton">Save</Button>
        <Button key="2" className="cancelButton ml1 mt3" onClick={() => handleCancelButton()}>Cancel</Button>
      </Form>
    );
  }

  const renderSubCategoryUi = () => {
    return (
      <Form layout="vertical"
        onFinish={handleSubmit}
        className="modal-form"
      >
        <Form.Item label="Category" name="name" rules={[{ required: true, message: 'Please enter name' }]}>
          <Input placeholder="Category name" />
        </Form.Item>
        <Form.Item label="Parent Category*" name="parent_id" rules={[{ required: true, message: 'Please select value' }]}>
          <Select
            placeholder="Select Parent Category"
          >
            {categoriesData && categoriesData.map(({ id, name }) => <Option key={id} value={id}>{name}</Option>)}
          </Select>
        </Form.Item>
        <Form.Item label="Account Code" name="account_code">
          <Input placeholder="Enter Category Code" />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <TextArea
            // value={value}
            // onChange={this.onChange}
            placeholder="Enter Description"
            autoSize={{ minRows: 3, maxRows: 5 }}
          />
        </Form.Item>
        <Form.Item>
          <Text className="mb1">Note : The policies of parent category will be applicable to subcategory,
            if you wish to change you can always edit in the subcategories under categories section</Text>
        </Form.Item>
        <Button key="1" htmlType="submit" className="formButton mt1">Save</Button>
        <Button key="2" className="cancelButton ml1 mt1" onClick={() => props.handleCancel()}>Cancel</Button>
      </Form>
    );
  }

  const handleSubmit = (values) => {
    const payload = {};
    if (categoryType === 'subCat') {
      [
        'name',
        'description',
        'account_code',
        'parent_id',
      ].forEach(item => {
        payload[item] = values[item];
      });
    } else {
      [
        'name',
        'description',
        'account_code',
      ].forEach(item => {
        payload[item] = values[item];
      });

      ['is_bill_mandatory',
        'is_document_mandatory',
        'is_submited_feature_bill'].forEach((item) => payload[item] = values[item]);
      //  'is_submited_feature_bill'].forEach((item) => payload[item] = JSON.parse(payload[item]));   
    }

    ValidationSchema.validate(payload)
      .then(function ({ ...value }) {
        Object.keys(payload).forEach(key => {
          if (payload[key] === undefined) {
            delete payload[key];
          }
        });
        currentId ?
          dispatch(addCategories(objectToFormData({ ...payload, id: currentId.toString() }))) :
          dispatch(addCategories(objectToFormData({ ...payload })));
        form.resetFields();
      })
      .catch(function (err) {
      });
  }

  return (
    <>
      <Radio.Group onChange={onChange} value={categoryType} className="category_type">
        <Radio value={'main'} disabled={currentId}>Main Category</Radio>
        <Radio value={'subCat'} disabled={currentId}>Sub-Category</Radio>
      </Radio.Group>
      {categoryType === 'main' ? renderMainCategoryUi() : renderSubCategoryUi()}
    </>
  );
}

export default AddCategory;

